import {type RestTypeWithTypename} from '../rest-type-with-typename';
import type {BillPayersResponse} from './bill-payers-data';

export function billPayersTypePatcher(data: BillPayersResponse): RestTypeWithTypename<BillPayersResponse> {
    return {
        __typename: 'BillPayersData',
        billPayers: data.billPayers.map(billPayer => ({__typename: 'BillPayer', ...billPayer})),
    };
}
